import React from 'react';
import ReactDOM from 'react-dom';

// Apollo Client
import { ApolloClient } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';

import App from './components/App';

// Apollo Config
const link = createHttpLink({
	uri: '/graphql',
	credentials: 'include'
});

const cache = new InMemoryCache({
	dataIdFromObject: object => object.id || null
});

const client = new ApolloClient({
	link,
	cache
});

ReactDOM.render(
	<ApolloProvider client={client}>
		<App />
	</ApolloProvider>,
	document.querySelector('#root')
);



// WEBPACK FOOTER //
// ./src/index.js